import { ICertificateIdentity } from './interfaces';

export const parseCertificateSubject = (subject: string): ICertificateIdentity => {
  const attributes: Record<string, string> = {};
  const text = subject.replace(/\n/g, ',');
  let index = 0;
  while (index < text.length) {
    while (index < text.length && /[\s,]/.test(text[index])) {
      index++;
    }
    const equals = text.indexOf('=', index);
    if (equals < 0) {
      break;
    }
    const key = text
      .slice(index, equals)
      .toUpperCase()
      .replace(/\s/g, '')
      .replace(/^OID\./, '');
    index = equals + 1;
    while (text[index] === ' ') {
      index++;
    }
    let value = '';
    if (text[index] === '"') {
      index++;
      while (index < text.length) {
        if (text[index] === '"') {
          if (text[index + 1] === '"') {
            value += '"';
            index += 2;
            continue;
          }
          index++;
          break;
        }
        value += text[index++];
      }
    } else {
      const start = index;
      while (index < text.length && text[index] !== ',') {
        index++;
      }
      value = text.slice(start, index).trim();
    }
    if (key && !(key in attributes)) {
      attributes[key] = value;
    }
  }
  const first = (keys: string[]) => keys.map((key) => attributes[key]).find((value) => value !== undefined) || '';
  const digits = (keys: string[]) => first(keys).replace(/\D/g, '');
  const commonName = attributes.CN || '';
  const given = first(['G', 'GN', 'GIVENNAME']).trim().split(/\s+/).filter(Boolean);
  return {
    snils: digits(['SNILS', 'СНИЛС', '1.2.643.100.3']),
    inn: digits(['INN', 'ИНН', '1.2.643.3.131.1.1']),
    innLe: digits(['INNLE', 'ИННЮЛ', '1.2.643.100.4']),
    lastName: first(['SN', 'SURNAME']),
    firstName: given[0] || '',
    middleName: given.slice(1).join(' '),
    position: first(['T', 'TITLE', '2.5.4.12']),
    commonName,
  };
};
